// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1GXgj","buttons":"Footer_buttons__3LQ1v"};